import React from 'react'
import classNames from 'classnames'
import {
  ImageResolutionsProps,
  RenderImgSourceProps
} from './ImageResolutions.d'
import { Card } from '@toasttab/shared/src/utils/craftUtils'

const RenderImgSource = ({
  altText,
  classes,
  dataTestId,
  image,
  minWidth,
  El
}: RenderImgSourceProps) => {
  const isSvg = image.extension === 'svg'
  const imgSrc =
    image.optimizedImages && !isSvg ? image.optimizedImages.srcAvif : image.url
  const unoptimizedImgType = isSvg ? 'svg+xml' : image.extension
  const imgType = image.optimizedImages && !isSvg ? 'webp' : unoptimizedImgType
  if (El === 'img') {
    return (
      <>
        <source
          className={classes}
          src={!minWidth ? imgSrc : null}
          srcSet={minWidth ? imgSrc : null}
          typeof={`image/${imgType}`}
        />
        <img
          alt={altText}
          className={classes}
          src={!minWidth ? image.url : null}
          srcSet={minWidth ? image.url : null}
          typeof={image.extension}
          data-testid={dataTestId}
        />
      </>
    )
  }
  return (
    <>
      <El
        role='img'
        className={classes}
        media={minWidth ? `(min-width: ${minWidth})` : null}
        src={!minWidth ? image.url : null}
        srcSet={minWidth ? image.url : null}
        typeof={image.extension}
      />
      <El
        role='img'
        className={classes}
        media={minWidth ? `(min-width: ${minWidth})` : null}
        src={!minWidth ? imgSrc : null}
        srcSet={minWidth ? imgSrc : null}
        typeof={`image/${imgType}`}
        data-testid={dataTestId}
      />
    </>
  )
}

const ImageResolutions = ({
  imageAlt,
  images,
  mobileBleed = false,
  pictureClasses = '',
  classes,
  borderRadius = 'None'
}: ImageResolutionsProps) => {
  const imageCorners = Card.borderRadius(borderRadius)
  const imgClasses = classNames(
    classes,
    imageCorners,
    'overflow-hidden lazyload',
    {
      '-mx-4 md:mx-0': mobileBleed
    }
  )

  const imgResolutions = images?.imageResolutions && images.imageResolutions[0]
  if (!imgResolutions) return <></>

  const desktop =
    imgResolutions.desktop && imgResolutions.desktop.length > 0
      ? imgResolutions.desktop[0]
      : null
  const tablet =
    imgResolutions.tablet && imgResolutions.tablet.length > 0
      ? imgResolutions.tablet[0]
      : null
  const mobile =
    imgResolutions.mobile && imgResolutions.mobile.length > 0
      ? imgResolutions.mobile[0]
      : null
  const altText = imageAlt
    ? imageAlt
    : desktop?.description
    ? desktop.description
    : desktop?.title

  return (
    desktop && (
      <picture data-testid='mds-imageResolutions' className={pictureClasses}>
        <RenderImgSource
          dataTestId='mds-imageResolutions-source-desktop'
          El='source'
          image={desktop}
          minWidth='992px'
        />
        <RenderImgSource
          dataTestId='mds-imageResolutions-source-tablet'
          El='source'
          image={tablet || desktop}
          minWidth='768px'
        />
        <RenderImgSource
          altText={altText}
          dataTestId='mds-imageResolutions-img'
          image={mobile || desktop}
          El='img'
          classes={imgClasses}
        />
      </picture>
    )
  )
}

export default ImageResolutions
